import { Input } from "reactstrap";

const IconInput = ({
  type,
  value,
  setValue,
  placeholder,
  Icon,
  className,
  error,
}) => {
  return (
    <div className={`icon-input ${className}`}>
      <div>
        <Icon size={30} />
      </div>
      <Input
        className={error ? "border-danger" : ""}
        type={type}
        value={value}
        onChange={(e) => setValue(e?.target?.value)}
        placeholder={placeholder}
      />
    </div>
  );
};

export default IconInput;
